import React, { useState } from 'react';
import { dayString } from '../../../utils/recordDate';
import createRecord from '../../../api/services/createRecord';
import { useNavigate } from 'react-router-dom';

// components
import Header from '../../../components/Header/Header';
import HookForm from '../../../components/HookForm/HookForm';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Alert from '../../../components/Alert/Alert';
import Loader from '../../../components/Loader/Loader';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectServiceStatuses from '../../../components/Selects/SelectServiceStatuses';
import SelectSources from '../../../components/Selects/SelectSources';
import Select from '../../../components/Select/Select';
import SelectMarks from '../../../components/Selects/SelectMarks';
import SelectModels from '../../../components/Selects/SelectModels';
import SelectServiceAddress from '../../../components/Selects/SelectServiceAddress';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';

// icons
import icon from '../../../brand/generated/sidebar/records.svg';
import alert from '../../../helpers/alert';

const formStyles = {
  record: {
    display: 'grid',
    gap: '20px',
    gridTemplateAreas: `'a a k k' 'b b b b' 'c c v v' 'd d d d' 'f f f f' 'n n n n'`,
  },
};

// ÐÐ°ÑÐºÐ° Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ Ð² Ð¿Ð¾Ð»Ðµ mark, Ð° ÑÐ°Ð»Ð¾Ð½Ñ ÑÐ¸Ð»ÑÑÑÑÑÑÑÑ Ð¿Ð¾ ÐµÑ id.
const markId = (mark) => mark?.value;

const AddRecordTestdrive = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [service, setService] = useState([
    { name: 'date', label: 'ÐÐ°ÑÐ°', value: '01.11.2022', disabled: true },
    { name: 'id', label: 'ID', value: '35567809', disabled: true },
    { name: 'userId', component: SelectClients, style: { gridArea: 'k' } },
    {
      name: 'status',
      component: SelectServiceStatuses,
      label: 'Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    },
    { name: 'sourceId', component: SelectSources, label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    { name: 'created_at', type: 'date', value: new Date(), label: 'ÐÐ°ÑÐ°', component: Datepicker },
    {
      name: 'time',
      component: Select,
      label: 'ÐÑÐµÐ¼Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: [
        { value: '09:00', label: '09:00' },
        { value: '10:30', label: '10:30' },
        { value: '12:00', label: '12:00' },
        { value: '13:30', label: '13:30' },
        { value: '15:00', label: '15:00' },
        { value: '16:30', label: '16:30' },
      ],
    },
    {
      name: 'service',
      component: Select,
      label: 'Ð£ÑÐ»ÑÐ³Ð°',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: [{ value: 1, label: 'Ð¢ÐµÑÑ-Ð´ÑÐ°Ð¹Ð²' }],
      style: { gridArea: 'c' },
    },
    { name: 'mark', component: SelectMarks },
    {
      name: 'model',
      component: SelectModels,
      dependency: 'mark',
      dependencyAccessor: (obj) => obj?.value,
    },
    {
      name: 'dealerAddressId',
      component: SelectServiceAddress,
      // Ð¢Ð¾ÑÐºÐ° Ð²Ð¸Ð·Ð¸ÑÐ° Ð²Ð¼ÐµÑÑÐ¾ Ð¿ÑÐµÐ¶Ð½ÐµÐ³Ð¾ Ð²ÑÐ±Ð¾ÑÐ° ÐÐ¦: ÑÐ¾Ñ â ÑÑÐ»Ð¸ÑÐ¾ Ð¿Ð¾Ð´ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ,
      // Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ Ã Ð³Ð¾ÑÐ¾Ð´Ñ, ÐµÑÐ°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð½Ðµ ÑÑÐ´Ð°.
      typeId: 1,
      dependency: 'mark',
      dependencyAccessor: markId,
      label: 'ÐÐ´ÑÐµÑ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð°',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'd' },
    },
    {
      name: 'manager',
      component: Select,
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'f' },
    },
    {
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'n' },
    },
  ]);

  const addRecord = (data) => {
    setLoading(true);
    const day = dayString(data.created_at);
    const time = data?.time?.value;
    const payload = {
      sourceId: data?.sourceId?.value,
      markId: data?.mark?.value,
      modelId: data?.model?.value,
      date: day + ' ' + time + ':00',
      typeId: data?.service?.value,
      dealerAddressId: data?.dealerAddressId?.value,
      userId: data?.userId?.value,
    };
    createRecord(payload)
      .then((res) => {
        setSucces({ message: 'ÐÐ°Ð¿Ð¸ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°' });
        setTimeout(() => {
          navigate('/records');
        }, 1000);
      })
      .catch((error) => {
        alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response))
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <div style={{ paddingBottom: '20px' }}>
        <Header title="ÐÐ¾Ð²Ð°Ñ Ð·Ð°Ð¿Ð¸ÑÑ Ð½Ð° ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²" icon={icon} />
        <Breadcrumbs navigate={'/records'} link={'ÐÐ°Ð¿Ð¸ÑÐ¸'} currentPage={'ÐÐ¾Ð²Ð°Ñ Ð·Ð°Ð¿Ð¸ÑÑ'} />
        <HookForm
          inputs={service}
          title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸'}
          handlerSetState={setService}
          grid={formStyles.record}
          border
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'}
          onSubmit={addRecord}
        />
      </div>
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default AddRecordTestdrive;
